import {findNode} from "./findNode.js";
export const someNode = (editor, options) => {
  return !!findNode(editor, options);
};
